var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useQuery } from 'react-query';
import { useOkapiKy } from '@folio/stripes/core';
import { getHeaders } from '../api/apiUtils';
var USER_SEARCH_PATH = 'czna-users/users';
var STALE_TIME_MS = 5 * 60 * 1000; // 5 minutes
/**
 * CZNA-791 — may the signed-in user search the user collection
 * (`czna-users.users.collection.get`)? A cataloguer may not, and the creator filter's
 * autocomplete then 403s into an empty list that reads as "no such user".
 *
 * <p><b>Why a probe and not `stripes.hasPerm`.</b> Until CZNA-1425 `platform-czna/stripes.config.js`
 * set `hasAllPerms: true`, so `hasPerm` answered yes for every permission and every user — the
 * first version of this fix gated on it and the cataloguer e2e spec still found the
 * filter. Asking the endpoint the filter would call is the one answer that cannot drift
 * from what the sidecar enforces.
 *
 * <p>Only a 403 means "may not", and it RESOLVES rather than throws, so react-query never
 * retries a refusal. Any other failure is rethrown and gets react-query's default retries;
 * `canSearchUsers` stays false until a probe has actually succeeded.
 */
var useCanSearchUsers = function () {
    var ky = useOkapiKy();
    var data = useQuery(['czna-users-search-allowed'], function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ky.get(USER_SEARCH_PATH, { searchParams: { limit: 1 }, headers: getHeaders() })];
                case 1:
                    _b.sent();
                    return [2 /*return*/, true];
                case 2:
                    err_1 = _b.sent();
                    if (((_a = err_1 === null || err_1 === void 0 ? void 0 : err_1.response) === null || _a === void 0 ? void 0 : _a.status) === 403)
                        return [2 /*return*/, false];
                    throw err_1;
                case 3: return [2 /*return*/];
            }
        });
    }); }, { staleTime: STALE_TIME_MS }).data;
    return { canSearchUsers: data === true };
};
export default useCanSearchUsers;
